(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.setHeaderHeight();
      window.addEventListener('scroll', this.onScroll.bind(this), false);
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 100) { this.header.classList.add('scrolled-past-header'); } 
      else { this.header.classList.remove('scrolled-past-header'); }
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
